export default __webpack_public_path__ + "static/media/rotate180.b47ec76d.svg";